module.exports = function() {
  return new Worker(__webpack_public_path__ + "cb56c28b8a9a18475734.worker.js");
};